export default __webpack_public_path__ + "static/media/falcon_join_2.3c3a36b4.svg";